import { countryState } from '@core/country/stores/country.store'
import { productsApi } from '../services/products.apis'
import { availableProductWarehousesState, productsState } from '../stores/products.store'
import { useTransition } from 'react'
import { useSetAtom } from 'jotai'
import { useAtomValue } from 'jotai'
import { enrollStarterKitProductsState } from '../stores/enrollStarterKitProducts.store'
import { loadingProductsState } from '../stores/loading.store'
import { renewalProductsState } from '../stores/renewalProducts.store'

export function useProducts({ allow = 'shop', status = '' }: { allow?: string; status?: string }) {
    const [isPending, startTransition] = useTransition()
    const setProducts = useSetAtom(productsState)
    const setAvailableProductWarehouses = useSetAtom(availableProductWarehousesState)
    const setEnrollStarterKitProducts = useSetAtom(enrollStarterKitProductsState)
    const setRenewalProducts = useSetAtom(renewalProductsState)
    const country = useAtomValue(countryState)
    const setIsLoading = useSetAtom(loadingProductsState)
    const getProducts = (warehouse = 'Main') => {
        setIsLoading(true)
        startTransition(async () => {
            try {
                const response = await productsApi.getProducts({ countryCode3Alpha: country.short, userStatus: status, allow, warehouse })
                setProducts(response.data.items)
                setAvailableProductWarehouses(Array.isArray(response.data.warehouses) ? response.data.warehouses : [])
                if (allow === 'urenew') {
                    setEnrollStarterKitProducts(response.data.starter_kit ?? [])
                    setRenewalProducts(response.data.renewal || [])
                }
            } catch (error) {
                console.error('Failed to fetch products:', error)
            } finally {
                setIsLoading(false)
            }
        })
    }

    return {
        getProducts,
        isPending
    }
}
